import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { useIntl } from 'react-intl';
import { ComparisonData } from '../../pages/Planner';
import TimeAccumulationPlot from './TimeAccumulationPlot';
import { Plan, SectionData } from '../../services/PlansService';

interface ComparisonViewProps {
    plan: Plan;
    sectionsData: SectionData[];
    comparisonData: ComparisonData;
    isLoading: boolean;
}

export const ComparisonView: React.FC<ComparisonViewProps> = ({
    plan,
    sectionsData,
    comparisonData,
    isLoading
}) => {
    const intl = useIntl();

    if (isLoading) {
        return (
            <Box height="100%" minHeight="300px" display="flex" alignItems="center" justifyContent="center">
                <CircularProgress />
            </Box>
        );
    }

    if (!comparisonData) {
        return (
            <Box height="100%" minHeight="300px" display="flex" alignItems="center" justifyContent="center">
                <Typography>
                    {intl.formatMessage({ id: 'plans.noComparisonData' })}
                </Typography>
            </Box>
        );
    }

    const { streams } = comparisonData;


    return (
        <Box display="flex" flexDirection="column" height="100%" minHeight="300px" overflow="auto" p={1}>
            {streams && streams.velocity_smooth && streams.distance ? (
                <Box>
                    <Box width="100%" overflow="hidden">
                        <TimeAccumulationPlot
                            id="activity-pace-chart"
                            activityStreams={streams}
                            sectionsData={sectionsData}
                            plan={plan}
                            dimensions={{
                                width: 600,
                                height: 300,
                                margin: { top: 20, right: 0, bottom: 30, left: 52 } // Reduced bottom margin
                            }}
                        />
                    </Box>
                </Box>
            ) : (
                <Box
                    p={4}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexGrow={1}
                    sx={{
                        border: '1px dashed grey',
                        borderRadius: 1,
                        minHeight: '300px',
                        backgroundColor: 'rgba(0,0,0,0.03)'
                    }}
                >
                    <Typography color="text.secondary" textAlign="center">
                        {intl.formatMessage({ id: 'plans.noStreamData' })}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};